import api from "../../utils/apiUser";

export const getCategorias = async () => {
  const res = await api.get("/api/categorias");
  return res.data.categorias;
};

export const createCategoria = async (data) => {
  const res = await api.post("/api/categorias", data);
  return res.data;
};

export const updateCategoria = async (id, data) => {
  const res = await api.put(`/api/categorias/${id}`, data);
  return res.data;
};
